import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from "@angular/forms";
import { IPerson } from "src/app/interfaces";

@Component({
    selector: "people-picker",
    templateUrl: "./people-picker.component.html",
    styleUrls: ["./people-picker.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PeoplePickerComponent,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: PeoplePickerComponent,
            multi: true
        }
    ],
    standalone: false
})
export class PeoplePickerComponent implements ControlValueAccessor, Validator {
  @Input() public set maxPeople(value: number) {
    this._maxPeople = value;
    this.onValidatorChange();
  }
  @Input() public value: IPerson[];
  @Output() public valueChange = new EventEmitter<IPerson[]>();
  @Input() public disabled = false;
  @Input() public loading = false;
  @Input() public data: IPerson[];
  @Input() public noDataText: string;
  @Input() public placeholder: string;

  @Output() public filterChange = new EventEmitter<string>();
  public focusChange = new EventEmitter<void>();

  /* eslint-disable @typescript-eslint/no-empty-function */
  private onValidatorChange: () => void = () => {};
  private onChange: (newVal: IPerson | IPerson[]) => void = () => {};
  private onTouched: () => void = () => {};
  /* eslint-enable @typescript-eslint/no-empty-function */

  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  public get maxPeople(): number {
    return this._maxPeople;
  }
  private _maxPeople = null;

  public internalValueChange(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    newVal: IPerson[]
  ): void {
    if (this.maxPeople == 1) {
      this.onChange(this.value[0]);
    } else {
      this.onChange(this.value);
    }
    this.onTouched();
    this.valueChange.emit(this.value);
  }

  /** Validator */
  validate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    control: AbstractControl
  ): ValidationErrors {
    if (this.maxPeople && this.value.length > this.maxPeople) {
      return {
        singleSelection: this.value.length
      };
    }

    // all is fine
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  /** ControlValueAccessor */
  writeValue(obj: IPerson | IPerson[]): void {
    // set value from external
    if (!obj) {
      this.value = [];
      this.internalValueChange(this.value);
      return;
    }

    const objIsArray = typeof (obj as IPerson[]).length === undefined;

    if (this.maxPeople && this.maxPeople == 1 && !objIsArray) {
      this.value = [obj as IPerson];
    } else {
      this.value = obj as IPerson[];
    }
    this.internalValueChange(this.value);
  }
  registerOnChange(fn: (x: IPerson | IPerson[]) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public blur(): void {
    this.onTouched();
  }

  /** Not needed?! */
  /* eslint-disable @typescript-eslint/no-empty-function */
  public close(): void {}
  public open(): void {}
  public focus(): void {
    this.focusChange.emit();
  }
}
